import { action, computed, reaction, makeObservable } from 'mobx';
import {CarouselStore} from '../../../../../lib/components/CarouselStore';
import {Disposers} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {SlideShowModel} from '../models';
import {SlideShowState} from './models';

export class SlideShowStore {
  private readonly disposers = new Disposers();

  readonly carousel: CarouselStore;

  constructor(readonly id: number,
              readonly model: SlideShowModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
    this.carousel = new CarouselStore(this.model.slides.length - 1);
    this.setup();
  }

  @computed
  get slideShowState(): SlideShowState | null {
    const altSlideShowState: SlideShowState = { currentSlide: 0 };
    return this.stateStore.getContentState<SlideShowState>(this.id) ? this.stateStore.getContentState<SlideShowState>(this.id) : altSlideShowState;
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.slideShowState?.currentSlide,
        this.updateCarouselState,
        {fireImmediately: true}
      ),
      reaction(
        () => this.carousel.index,
        this.updateKvStore
      )
    );
  }

  @action
  private updateCarouselState = () => {
    if (this.slideShowState === null)
      return;
    this.carousel.setIndex(this.slideShowState.currentSlide);
  };

  @action
  private updateKvStore = () => {
    if (this.slideShowState === null)
      return;
    if (this.carousel.index === this.slideShowState.currentSlide)
      return;
    const state: SlideShowState = {currentSlide: this.carousel.index};

    this.stateStore.setContentState<SlideShowState>(this.id,
      state);
  };

  dispose() {
    this.disposers.dispose();
  }
}
